// Generated automatically by nearley
// http://github.com/Hardmath123/nearley
(function() {
    function id(x) {
        return x[0];
    }

    function structuredExpression(arr) {
        var field = arr[0];
        var operator = arr[2];
        var value = arr[4];
        var additionalField;
        var separatorField;

        // необходимый костыль, так как в field может содержаться все выражение (особенность парсера),
        // а разбивать числа по точке нельзя
        if (field.includes('.') && !field.includes('<') && !field.includes('>')) {
            var splitFieldList = field.split('.');
            separatorField = '.';
            field = splitFieldList[0];
            additionalField = splitFieldList.slice(1).join('.');
        }

        return {
            field: field + (arr[1] && arr[1].length && !operator ? ' ' : ''),
            operator: operator,
            value: value ? value : arr[3] ? '' : undefined,
            separatorField,
            additionalField
        };
    }
    var grammar = {
        Lexer: undefined,
        ParserRules: [
            {
                name: 'Expression',
                symbols: ['_', 'StructuredExpression', '_'],
                postprocess: function(a) {
                    return a[1];
                }
            },
            {
                name: 'StructuredExpression',
                symbols: ['field', '_'],
                postprocess: structuredExpression
            },
            {
                name: 'StructuredExpression',
                symbols: ['field', '_', 'operatorWithoutWhitespace', '_'],
                postprocess: structuredExpression
            },
            {
                name: 'StructuredExpression',
                symbols: ['field', '__', 'operatorWithWhitespace', '_'],
                postprocess: structuredExpression
            },
            {
                name: 'StructuredExpression',
                symbols: ['field', '_', 'operatorWithoutWhitespace', '_', 'value'],
                postprocess: structuredExpression
            },
            {
                name: 'StructuredExpression',
                symbols: ['field', '__', 'operatorWithWhitespace', '__', 'value'],
                postprocess: structuredExpression
            },
            { name: 'field', symbols: ['Sentence'], postprocess: id },
            {
                name: 'operatorWithWhitespace$string$1',
                symbols: [
                    { literal: 'с' },
                    { literal: 'о' },
                    { literal: 'д' },
                    { literal: 'е' },
                    { literal: 'р' },
                    { literal: 'ж' },
                    { literal: 'и' },
                    { literal: 'т' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$1'],
                postprocess: id
            },
            {
                name: 'operatorWithWhitespace$string$2',
                symbols: [
                    { literal: 'н' },
                    { literal: 'е' },
                    { literal: ' ' },
                    { literal: 'с' },
                    { literal: 'о' },
                    { literal: 'д' },
                    { literal: 'е' },
                    { literal: 'р' },
                    { literal: 'ж' },
                    { literal: 'и' },
                    { literal: 'т' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$2'],
                postprocess: id
            },
            {
                name: 'operatorWithWhitespace$string$3',
                symbols: [
                    { literal: 'c' },
                    { literal: 'o' },
                    { literal: 'n' },
                    { literal: 't' },
                    { literal: 'a' },
                    { literal: 'i' },
                    { literal: 'n' },
                    { literal: 's' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$3'],
                postprocess: id
            },
            {
                name: 'operatorWithWhitespace$string$4',
                symbols: [
                    { literal: 'd' },
                    { literal: 'o' },
                    { literal: 'e' },
                    { literal: 's' },
                    { literal: 'n' },
                    { literal: '’' },
                    { literal: 't' },
                    { literal: ' ' },
                    { literal: 'c' },
                    { literal: 'o' },
                    { literal: 'n' },
                    { literal: 't' },
                    { literal: 'a' },
                    { literal: 'i' },
                    { literal: 'n' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$4'],
                postprocess: id
            },
            {
                name: 'operatorWithWhitespace$string$5',
                symbols: [
                    { literal: 'i' },
                    { literal: 'ç' },
                    { literal: 'e' },
                    { literal: 'r' },
                    { literal: 'i' },
                    { literal: 'y' },
                    { literal: 'o' },
                    { literal: 'r' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$5'],
                postprocess: id
            },
            {
                name: 'operatorWithWhitespace$string$6',
                symbols: [
                    { literal: 'i' },
                    { literal: 'ç' },
                    { literal: 'e' },
                    { literal: 'r' },
                    { literal: 'm' },
                    { literal: 'i' },
                    { literal: 'y' },
                    { literal: 'o' },
                    { literal: 'r' }
                ],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithWhitespace',
                symbols: ['operatorWithWhitespace$string$6'],
                postprocess: id
            },
            {
                name: 'operatorWithoutWhitespace$string$1',
                symbols: [{ literal: '>' }, { literal: '=' }],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithoutWhitespace',
                symbols: ['operatorWithoutWhitespace$string$1'],
                postprocess: id
            },
            {
                name: 'operatorWithoutWhitespace$string$2',
                symbols: [{ literal: '<' }, { literal: '=' }],
                postprocess: function joiner(d) {
                    return d.join('');
                }
            },
            {
                name: 'operatorWithoutWhitespace',
                symbols: ['operatorWithoutWhitespace$string$2'],
                postprocess: id
            },
            {
                name: 'operatorWithoutWhitespace',
                symbols: [{ literal: '=' }],
                postprocess: id
            },
            {
                name: 'operatorWithoutWhitespace',
                symbols: [{ literal: ':' }],
                postprocess: id
            },
            { name: 'value', symbols: ['Sentence'], postprocess: id },
            { name: 'Sentence$ebnf$1', symbols: [] },
            {
                name: 'Sentence$ebnf$1$subexpression$1',
                symbols: ['__', 'Word']
            },
            {
                name: 'Sentence$ebnf$1',
                symbols: ['Sentence$ebnf$1', 'Sentence$ebnf$1$subexpression$1'],
                postprocess: function arrpush(d) {
                    return d[0].concat([d[1]]);
                }
            },
            {
                name: 'Sentence',
                symbols: ['Word', 'Sentence$ebnf$1'],
                postprocess: function(arr) {
                    var head = arr[0],
                        tail = arr[1];

                    return [head]
                        .concat(
                            tail.map(function(expr) {
                                return expr[1];
                            })
                        )
                        .join(' ');
                }
            },
            { name: 'Word$ebnf$1', symbols: ['char'] },
            {
                name: 'Word$ebnf$1',
                symbols: ['Word$ebnf$1', 'char'],
                postprocess: function arrpush(d) {
                    return d[0].concat([d[1]]);
                }
            },
            {
                name: 'Word',
                symbols: ['Word$ebnf$1'],
                postprocess: function(arr) {
                    return arr[0].join('');
                }
            },
            { name: 'char', symbols: [/[^\s\n|]/], postprocess: id },
            { name: '_$ebnf$1', symbols: [] },
            {
                name: '_$ebnf$1',
                symbols: ['_$ebnf$1', 'wschar'],
                postprocess: function arrpush(d) {
                    return d[0].concat([d[1]]);
                }
            },
            { name: '_', symbols: ['_$ebnf$1'], postprocess: id },
            { name: '__$ebnf$1', symbols: ['wschar'] },
            {
                name: '__$ebnf$1',
                symbols: ['__$ebnf$1', 'wschar'],
                postprocess: function arrpush(d) {
                    return d[0].concat([d[1]]);
                }
            },
            { name: '__', symbols: ['__$ebnf$1'], postprocess: id },
            { name: 'wschar', symbols: [/[\s]/], postprocess: id }
        ],
        ParserStart: 'Expression'
    };
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = grammar;
    } else {
        window.grammar = grammar;
    }
})();
